export default {
  Account: `Account`,
  Features: `Features`,
  Pricing: `Pricing`,
  FAQ: `FAQ`,
  Contact: `Contact`,
  "Log in": `Log in`,
  "UNITED BANKING": `UNITED BANKING`,
  "Connect your partners into unified ecosystem for rapid and secure fund flows": `Connect your partners into unified ecosystem <br />for rapid and secure fund flows`,
  header: {
    "Sign Up": `Sign Up`,
  },
  account: {
    "PERSONAL AND BUSINESS ACCOUNT": `PERSONAL<br />AND BUSINESS<br> ACCOUNT`,
    "Manage all your financial transactions": `Manage all your financial transactions,<br> make and receive payments.<br> All-in-one space.`,
    "Create Account": `Create Account`,
    Fast: `Fast`,
    Simple: `Simple`,
    Global: `Global`,
    "Fast online application and onboarding": `Fast online application and onboarding`,
    "Execute all banking tasks at lightspeed": `Execute all banking tasks at lightspeed`,
    "SEPA & SWIFT for easy fund transfers globally": `SEPA & SWIFT for easy fund transfers globally`,
    "Crypto payments and investments": `Crypto payments and investments`,
    "Personalized support available anytime": `Personalized support available anytime`,
    "TOP-TIER SECURITY": `TOP-TIER SECURITY`,
    Trust: `Trust in our state-of-the-art security protocols designed to provide peace of mind, so you can focus on managing your finances with confidence.`,
    "SMOOTH TRANSACTIONS": `SMOOTH TRANSACTIONS`,
    "INTEGRATED ECOSYSTEM": `INTEGRATED ECOSYSTEM`,
    "Our platform": `Our platform connects all your partners, employees, and contractors in one unified hub. Experience seamless collaboration and streamlined communication across your entire network.`,
    Experience: `Experience seamless and efficient transactions like never before. Our platform ensures every payment and banking task is processed swiftly, securely,and without hassle.`,
  },
  features: {
    "UNITY AT THE CORE": `UNITY AT THE CORE`,
  },
  EXPLORE: `EXPLORE`,
  "EXPLORE A COMPLETE FINANCIAL PLATFORM POWERED BY BANK ACCOUNT": `EXPLORE A COMPLETE FINANCIAL PLATFORM POWERED BY BANK ACCOUNT`,
  pricing: {
    "ON REQUEST": `ON REQUEST`,
    PRICING: `PRICING`,
    "EXPLORE OUR PRICING": `EXPLORE OUR PRICING`,
    BUSINESS: `BUSINESS`,
    PERSONAL: `PERSONAL`,
    "PRIVATE INDIVIDUALS": `PRIVATE INDIVIDUALS`,
    "Contact Sales": `Contact Sales`,
    "Handling of documents and opening a customer account": `Handling of documents and opening a customer account`,
    "Account monthly service fee": `Account monthly service fee`,
    "Incoming internal payment": `Incoming internal payment`,
    "Incoming SEPA-payment": `Incoming SEPA-payment`,
    "Incoming SWIFT-payment": `Incoming SWIFT-payment`,
    "Internal outgoing payment between own accounts with in Swipez": `Internal outgoing payment between own accounts within Swipez`,
    "Internal outgoing payment with in Swipez": `Internal outgoing payment within Swipez`,
    "Internal outgoing payment": `Internal outgoing payment`,
    "Outgoing SEPA-payment": `Outgoing SEPA-payment`,
    "Outgoing SWIFT-paymen": `Outgoing SWIFT-paymen`,
    "Opening a customer account": `Opening a customer account`,
    "Withdrawal to card": `Withdrawal to card`,
    "Payment card top-up": `Payment card top-up`,
    "Free of change": `Free of change`,
  },
  faq: {
    FAQ: `FAQ`,
  },
  questtions: {
    "FREQUENTLY ASKED QUESTIONS": `FREQUENTLY<br>ASKED QUESTIONS`,
    "Swipez company is registered in the Czech Republic": `Swipez company is registered in the Czech Republic`,
    "What country is Swipez registered at?": `What country is Swipez registered at?`,
    "We use technologies that guarantee secure online payments and two-factor authentication": `We use technologies that guarantee secure online payments and two-factor authentication. Moreover, users receive real time notifications about all transactions on the account.`,
    "Funds of our customers are kept in a separate account in the Czech bank": `Funds of our customers are kept in a separate account in the Czech bank and can be used by no one, except for the customer, i.e. they are protected 100%.`,
    "When opening an account, a passport or ID card is required": `When opening an account, a passport or ID card is required, as well as utility bill or a bank statement on the account with your name and address`,
    "You will get access as soon as your identity is checked and verified": `You will get access as soon as your identity is checked and verified. Usually, it takes from 30 minutes to several hours.`,
    "Currently, an account may be opened": `Currently, an account may be opened, if you are over 18 and you are not a resident of the following countries: Afghanistan, Albania, Algeria, Central African Republic, China, Cuba, Democratic Republic of Congo, Ecuador, Guyana, Indonesia, India, Iran, Iraq, Ivory Coast, Nigeria, North Korea, Laos, Panama, Papua New Guinea, Russia, Sudan, Syria, Uganda, Yemen, Zimbabwe.`,
    "How safe is Swipez service?": `How safe is Swipez service?`,
    "How safe is it to keep money at Swipez?": `How safe is it to keep money at Swipez?`,
    "What documents must be presented for opening an account?": `What documents must be presented for opening an account?`,
    "When will I get access to the online bank?": `When will I get access to the online bank?`,
    "Residents of what countries may not open an account?": `Residents of what countries may not open an account?`,
  },
  footer: {
    "NEED OUR TEAM HELP?": `NEED OUR<br> TEAM HELP?`,
    "Privacy Policy": `Privacy Policy`,
    "Terms and Conditions": `Terms and Conditions`,
    "Claims Procedure": `Claims Procedure`,
    "Cryptocurrency Exchange Notice": `Cryptocurrency Exchange Notice`,
    desk0: `To learn about which Revolut company serves you or if you have any questions, please contact us through our in-app chat.`,
    desk1: `Revolut Ltd is registered in England and Wales (No. 08804411), 7 Westferry Circus, Canary Wharf, London, England, E14 4HD and is authorised by the Financial Conduct Authority under the Electronic Money Regulations 2011 (Firm Reference 900562). Revolut Travel Ltd is authorised by the Financial Conduct Authority to undertake insurance distribution activities (FCA No: 780586). Our insurance products are arranged by Revolut Travel Ltd and Revolut Ltd, which is an appointed representative of Revolut Travel Ltd. Revolut’s stock trading products are provided by Revolut Trading Ltd (No. 832790), an appointed representative of Resolution Compliance Ltd, which is authorised and regulated by the Financial Conduct Authority.`,
    desk2: `Revolut Ltd is also registered with the Financial Conduct Authority to offer cryptocurrency services under the Money Laundering, Terrorist Financing and Transfer of Funds (Information on the Payer) Regulations 2017. Precious metals services are provided by Revolut Ltd and are not regulated by the Financial Conduct Authority.`,
    "Complaints Disclaimer": `Complaints Disclaimer`,
    "Safeguarding Disclaimer": `Safeguarding Disclaimer`,
    "All rights reserved": `All rights reserved. All other trademarks, product names and logos identified or mentioned herein are the property of their respective owners. While using this website and/or our services you agree to have carefully read, accepted and became legally bound by the Terms and Conditions , Complaints Policy , Privacy Policy. The operator of this website is Draph Solutions s.r.o., with its headquarters in Národní 961/25, Staré Město, 110 00 Praha 1, Czech Republic, Czech-based financial institution, licensed and regulated by the Czech National Bank, legally auth for provision of personal and business current accounts and for provision of domestic and international payments. Licence granted by the Czech National Bank pursuant to Act No. 370/2017 Coll. Payment Services Act.`,
  },
  Call: `Call`,
  Email: `Email`,
  "Back to website": `Back to website`,
  privacyPolicy: {
    Privacy: `Privacy`,
    Policy: `Policy`,
  },
  terms: {
    Terms: `Terms`,
    And: `And`,
    Conditions: `Conditions`,
  },
  complaints: {
    complaints: `Complaints`,
    disclaimer: `Disclaimer`,
  },
  safeguarding: {
    safeguarding: `SAFEGUARDING`,
    disclaimer: `DISCLAIMER`,
  },
};
